import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { LogistikProductTargetAudience } from '@chancenwerk/db/enums/LogistikEnums.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement logistik-component-audience-tag
 */
@customElement('logistik-component-audience-tag')
export class LogistikComponentAudienceTag extends ChemistryLitElement {
  @property({ type: LogistikProductTargetAudience, reflect: true }) audience = LogistikProductTargetAudience.ALL;

  override render() {
    return html`
      <cr-flex padding="xs" ${css({ minWidth: 'min-content', background: '#f4f4f4', borderRadius: '5px' })}>
        <cr-text ${css({ fontSize: '0.8rem' })}>${this.audience}</cr-text>
      </cr-flex>
    `;
  }
}
